import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import FormSectionNavigator from '../../../components/ui/FormSectionNavigator';
import GuestBookForm from './GuestBookForm';
import VolunteerForm from './VolunteerForm';
import ArtSubmissionForm from './ArtSubmissionForm';

const EngagementFormsSection = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [activeForm, setActiveForm] = useState('guestbook');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('memorial-language') || 'en';
    setCurrentLanguage(savedLanguage);

    // Listen for language changes
    const handleLanguageChange = (event) => {
      const newLanguage = event.detail?.language || 'en';
      setCurrentLanguage(newLanguage);
    };

    window.addEventListener('languageChanged', handleLanguageChange);
    return () => window.removeEventListener('languageChanged', handleLanguageChange);
  }, []);

  const sectionContent = {
    ar: {
      title: "طرق المشاركة",
      subtitle: "شارك في فعالية الذكرى الأولى للتحرير",
      description: "اختر طريقة المشاركة المناسبة لك: الحضور، التطوع، أو الشراكة والدعم"
    },
    en: {
      title: "Ways to Participate",
      subtitle: "Join the First Anniversary of Liberation Event",
      description: "Choose the participation method that suits you: attendance, volunteering, or partnership and support"
    },
    tr: {
      title: "Katılım Yolları",
      subtitle: "Kurtuluşun İlk Yıldönümü Etkinliğine Katılın",
      description: "Size uygun katılım yöntemini seçin: katılım, gönüllülük veya ortaklık ve destek"
    }
  };

  const renderActiveForm = () => {
    switch (activeForm) {
      case 'volunteer':
        return <VolunteerForm />;
      case 'partner':
        return <ArtSubmissionForm />;
      default:
        return <GuestBookForm />;
    }
  };

  const content = sectionContent?.[currentLanguage];

  return (
    <section id="get-involved" className="py-16 lg:py-24 bg-surface">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="font-memorial text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-4">
            {content?.title}
          </h2>
          <p className="font-body text-xl text-accent mb-6">
            {content?.subtitle}
          </p>
          <p className="font-body text-base md:text-lg text-text-secondary max-w-3xl mx-auto">
            {content?.description}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="bg-card border border-border rounded-lg shadow-memorial overflow-hidden"
        >
          {/* Form Navigator */}
          <div className="border-b border-border">
            <FormSectionNavigator 
              activeForm={activeForm} 
              onFormChange={setActiveForm} 
            />
          </div>

          {/* Active Form */}
          <div className="p-6 md:p-8">
            {renderActiveForm()}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default EngagementFormsSection;